import React from 'react';
import { View, Text, Image, TouchableOpacity } from "react-native";
import { Feather, MaterialIcons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { useNavigation } from "@react-navigation/native";

import styles from './styles';

const HeaderTabs = ({ title, subtitle, iconLeft, iconRight, routeLeft, routeRight }) => {
    const navigation = useNavigation();
    return (
        <View style={subtitle === undefined ? styles.container : styles.containerSubtitle}>
            <View style={styles.content}>
                {
                    iconLeft === "settings" ? (
                        <Feather
                            name="settings"
                            size={24}
                            color="#fff"
                            style={styles.iconsHeader}
                            onPress={() => navigation.navigate(routeLeft)}
                        />
                    ) : iconLeft === "keyboard-arrow-left" ? (
                        <MaterialIcons
                            name="keyboard-arrow-left"
                            size={30}
                            color="#fff"
                            style={styles.iconsHeader}
                            onPress={() => navigation.goBack()}
                        />
                    ) : <></>
                }

                <Text style={iconRight !== undefined ? styles.title : styles.titleAnIcon}>{title}</Text>

                {
                    iconRight === "medal" &&
                    <TouchableOpacity onPress={() => navigation.navigate(routeRight)} >
                        <Image
                            source={require("../../../assets/tabs/icons/medal.png")}
                            style={styles.iconsHeaderRight}
                        />
                    </TouchableOpacity>
                }
            </View>

            {
                subtitle && (
                    <>
                        <View style={styles.hrLine}></View>
                        <Text style={styles.subtitle}>{subtitle}</Text>
                    </>
                )
            }
        </View>
    );
}

export default HeaderTabs;